/**
 * Flattens the profile JSON `data` column into scalar columns, shared by both
 * the network list and findSimilar (trigram) queries. Mirrors the legacy
 * `pgProfileColumnsLateral` helper.
 */
export const buildProfileColumnsLateral = (dataExpr: string): string => `
  CROSS JOIN LATERAL (
    SELECT
      (${dataExpr}->'official_name'->>'value') AS official_name,
      COALESCE((${dataExpr}->'display_name'->>'value'), (${dataExpr}->'official_name'->>'value'), 'Unknown') AS name,
      (${dataExpr}->'display_name'->>'value') AS display_name,
      (${dataExpr}->'transliterated_display_name'->>'value') AS transliterated_display_name,
      (${dataExpr}->'transliterated_official_name'->>'value') AS transliterated_official_name,
      (${dataExpr}->'description'->>'value') AS description,
      (${dataExpr}->'country'->>'value') AS country,
      (${dataExpr}->'country_name'->>'value') AS country_name,
      (${dataExpr}->'address_line_1'->>'value') AS address_line_1,
      (${dataExpr}->'address_line_2'->>'value') AS address_line_2,
      (${dataExpr}->'county'->>'value') AS county,
      (${dataExpr}->'zip_code'->>'value') AS zip_code,
      (${dataExpr}->'website'->>'value') AS website,
      (${dataExpr}->'phone'->>'value') AS phone,
      (${dataExpr}->'fac_email'->>'value') AS fac_email,
      (${dataExpr}->'company_size'->>'value') AS company_size,
      (${dataExpr}->'company_type'->>'value') AS company_type,
      (${dataExpr}->'founded'->>'value') AS founded,
      (${dataExpr}->'video_file'->>'value') AS video_file,
      (${dataExpr}->'collaboration_status'->>'value') AS collaboration_status,
      (${dataExpr}->'collaboration_start_date'->>'value') AS collaboration_start_date,
      (${dataExpr}->'retraced_risk_score'->>'value') AS retraced_risk_score,
      (${dataExpr}->'city'->>'value') AS city,
      (${dataExpr}->'collaboration_end_date'->>'value') AS collaboration_end_date,
      (${dataExpr}->'internal_company_code'->>'value') AS internal_company_code,
      (${dataExpr}->'notes'->>'value') AS notes,
      (${dataExpr}->'allow_sharing_address'->>'value') AS allow_sharing_address,
      (${dataExpr}->'allow_sharing_proof'->>'value') AS allow_sharing_proof,
      (${dataExpr}->'contact_person_email'->>'value') AS contact_person_email,
      (${dataExpr}->'enabled_custom_info'->>'value') AS enabled_custom_info
  ) company_property
`;
